import axios from 'axios';
import invariant from 'tiny-invariant';

async function updateCity(initiateTxn) {
  invariant(initiateTxn, 'initiate txn not found');

  const { data } = await axios.post(
    '/api/cities/update',
    { initiateTxn },
    {
      headers: {
        Authorization: process.env.NEXT_PUBLIC_API_KEY,
      },
    }
  );

  return data;
}

export default updateCity;
